import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import Axios from "axios"
import { toastError } from '../swal/toast'

export const AuthContext = createContext()

const useLogoutClient = () => {
    return async () => {
        localStorage.removeItem("jwt")
    }
}

const useLoginClient = (setClientauth) => {
    const navigate = useNavigate()

    return async (userCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }

        try {
            const result = await Axios.post(
                process.env.REACT_APP_DB_ADDRESS + "/api/login/in",
                { email: userCredentials.email, password: userCredentials.password },
                options
            )

            const token = result.data["token"]

            if (token && token !== "undefined") {
                localStorage.setItem("jwt", token)
                const decoded = jwtDecode(token)
                const hasTeacherRol = decoded.rol === "teacher" ? true : false

                setClientauth(decoded)

                if (hasTeacherRol) {
                    if (decoded.mustChangePassword) {
                        return navigate('/teacher/change-password')
                    }
                    return navigate('/teacher/dashboard')
                } else {
                    if (window.location.pathname !== '/') {
                        return navigate('/')
                    }
                }
            } else {
                toastError(result.data.message)
            }
        } catch (error) {
            console.error("Error al iniciar sesión:", error)
            toastError('Ocurrió un error al intentar iniciar sesión')
        }
    }
}

export function AuthProvider({ children }) {
    const [clientauth, setClientauth] = useState(null)
    const loginClient = useLoginClient(setClientauth)
    const logoutClient = useLogoutClient()
    const storedToken = localStorage.getItem("jwt")

    useEffect(() => {
        try {
            setClientauth(storedToken ? jwtDecode(storedToken) : null)
        } catch (error) {
            console.error("Error al decodificar el token:", error)
            setClientauth(null)
            localStorage.removeItem("jwt")
        }
    }, [storedToken])

    const contextValue = { clientauth, loginClient, logoutClient, setClientauth }

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context
}
